import React, { useContext, useState } from "react";
import useStyles from "./NotificationInformation.styles";
import { Checkbox, Button, Typography } from "@material-ui/core";
import { Trash, EnvelopeSimple, EnvelopeSimpleOpen } from "phosphor-react";

//components
import AssestVersion from "../../Utilities/Svg/AssestVersion.svg";
import ShotVersion from "../../Utilities/Svg/ShotVersion.svg";
import {
  Cube,
  FilmStrip,
  FilmSlate,
  Bell,
  CheckSquareOffset,
} from "phosphor-react";
import { MovieColabContext } from "../../../Context/MovieColabContext";

const NotificationInformation = ({
  notificationDetails,
  setNotificationIds,
  handleCheckNofications,
  checkedNotifications,
  readOneNotification,
  handleDeleteNotification,
  notificationIds,
  readNotifications,
}) => {
  const classes = useStyles();
  const { loggedInUser } = useContext(MovieColabContext);
  const [isRead, setIsRead] = useState(notificationDetails?.is_read);

  //function taskes a trackable type and returns the correct matched component
  const trackableIcon = (trackable) => {
    switch (trackable) {
      case "task":
        return <CheckSquareOffset className={classes.notificationDrop} />;
      case "asset":
        return <Cube className={classes.notificationDrop} />;
      case "assetversion":
        return <img src={AssestVersion} className={classes.notificationDrop} />;
      case "sequence":
        return <FilmStrip className={classes.notificationDrop} />;
      case "shot":
        return <FilmSlate className={classes.notificationDrop} />;
      case "shotversion":
        return <img src={ShotVersion} className={classes.notificationDrop} />;
      default:
        return <Bell className={classes.notificationDrop} />;
    }
  };

  // function that will help getting all the checked checkbox and thier ids
  const handleChange = (event, id) => {
    const selectedIndex = checkedNotifications.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(checkedNotifications, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(checkedNotifications.slice(1));
    } else if (selectedIndex === checkedNotifications.length - 1) {
      newSelected = newSelected.concat(checkedNotifications.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        checkedNotifications.slice(0, selectedIndex),
        checkedNotifications.slice(selectedIndex + 1),
      );
    }

    handleCheckNofications(newSelected);

    if (!event.target.checked) {
      setNotificationIds((prevItems) => {
        let filteredItem = prevItems.filter((eachItem) => eachItem !== id);
        return filteredItem;
      });
    } else {
      setNotificationIds((prevItems) => [...prevItems, id]);
    }
  };

  const getDisplayTime = (time) => {
    if (time.includes(":")) {
      return time;
    }
    let seconds = 0;
    let minutes = 0;
    if (time % 60) {
      minutes = parseInt(time / 60);
      seconds = parseInt(time % 60);
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
    }
    return `${minutes}:${seconds}`;
  };

  const checkLoggedInUser = (mentions) => {
    const isUserMentioned = mentions.some(
      (mention) => mention?.id === loggedInUser?.id,
    );
    return isUserMentioned;
  };

  const getNotificationText = (notification) => {
    switch (notification.notification_object.event_type) {
      case "asset_comment_mentioned":
      case "shot_comment_mentioned":
        return (
          <Typography>
            {notification.notification_object.content_object.author && (
              <span className={classes.highlightedCommentText}>
                {
                  notification.notification_object.content_object.author
                    .first_name
                }{" "}
                {
                  notification.notification_object.content_object.author
                    .last_name
                }{" "}
              </span>
            )}
            mentioned you in{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.version_object &&
                notification.notification_object.content_object.version_object
                  .name}
            </span>{" "}
            -{" "}
            {notification.notification_object.content_object.description &&
              getDisplayTime(
                notification.notification_object.content_object.description.split(
                  "<p>",
                )[0],
              )}{" "}
            {notification.notification_object.content_object.description && (
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    notification.notification_object.content_object.description
                      .split("<p>")[1]
                      ?.replace("<p>", "<div>")
                      ?.replace("</p>", "</div>"),
                }}
              />
            )}
          </Typography>
        );
      case "asset_comment_added":
      case "shot_comment_added":
        return (
          <Typography>
            {notification.notification_object.content_object.author && (
              <span className={classes.highlightedCommentText}>
                {
                  notification.notification_object.content_object.author
                    .first_name
                }{" "}
                {
                  notification.notification_object.content_object.author
                    .last_name
                }{" "}
              </span>
            )}
            {checkLoggedInUser(
              notification.notification_object?.content_object?.mentions,
            )
              ? "mentioned you in"
              : "commented on"}{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.version_object &&
                notification.notification_object.content_object.version_object
                  .name}
            </span>{" "}
            -{" "}
            {notification.notification_object.content_object.description &&
              getDisplayTime(
                notification.notification_object.content_object.description.split(
                  "<p>",
                )[0],
              )}{" "}
            {notification.notification_object.content_object.description && (
              <span
                dangerouslySetInnerHTML={{
                  __html:
                    notification.notification_object.content_object.description
                      .split("<p>")[1]
                      ?.replace("<p>", "<div>")
                      ?.replace("</p>", "</div>"),
                }}
              />
            )}
          </Typography>
        );
      case "asset_version_added":
      case "shot_version_added":
        return (
          <Typography>
            {notification.message} -{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.name}
            </span>{" "}
            by{" "}
            {notification.notification_object.content_object.created_by && (
              <span className={classes.highlightedCommentText}>
                {
                  notification.notification_object.content_object.created_by
                    .first_name
                }{" "}
                {
                  notification.notification_object.content_object.created_by
                    .last_name
                }
              </span>
            )}
          </Typography>
        );
      case "shot_status_updated":
      case "asset_status_updated":
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            Status for{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.name}
            </span>{" "}
            has been updated to{" "}
            {notification.notification_object.content_object.status && (
              <div
                style={{
                  height: "16px",
                  width: "16px",
                  margin: "0px 5px",
                  borderRadius: "50%",
                  border: "1px solid white",
                  backgroundColor: `rgba(${notification.notification_object.content_object.status.color})`,
                }}
              />
            )}{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.status &&
                notification.notification_object.content_object.status.name}
            </span>
            - by{" "}
            {notification.notification_object.content_object.updated_by && (
              <span className={classes.highlightedCommentText}>
                {
                  notification.notification_object.content_object.updated_by
                    .first_name
                }{" "}
                {
                  notification.notification_object.content_object.updated_by
                    .last_name
                }
              </span>
            )}
          </div>
        );
      case "review_version_added":
        return (
          <Typography>
            {notification.message} -{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.name}
            </span>{" "}
            by{" "}
            {notification.notification_object.content_object.created_by && (
              <span className={classes.highlightedCommentText}>
                {
                  notification.notification_object.content_object.created_by
                    .first_name
                }{" "}
                {
                  notification.notification_object.content_object.created_by
                    .last_name
                }
              </span>
            )}
          </Typography>
        );
      case "review_comment_added":
      case "review_comment_mentioned":
        return (
          <Typography>
            {notification.notification_object.content_object.user && (
              <span className={classes.highlightedCommentText}>
                {
                  notification.notification_object.content_object.user
                    .first_name
                }{" "}
                {
                  notification.notification_object.content_object.user.last_name
                }{" "}
              </span>
            )}
            commented on{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.version &&
                notification.notification_object.content_object.version.name}
            </span>{" "}
            -{" "}
            {notification.notification_object.content_object.text &&
              getDisplayTime(
                notification.notification_object.content_object.text.split(
                  "<p>",
                )[0],
              )}{" "}
            {notification.notification_object.content_object.text && (
              <span
                dangerouslySetInnerHTML={{
                  __html: notification.notification_object.content_object.text
                    .split("<p>")[1]
                    ?.replace("<p>", "<div>")
                    ?.replace("</p>", "</div>"),
                }}
              />
            )}
          </Typography>
        );
      case "user_added":
        return (
          <Typography>
            You have been added to project{" "}
            <span className={classes.highlightedCommentText}>
              {notification.notification_object.content_object.name}
            </span>
          </Typography>
        );
      default:
        return <Typography>{notification.message}</Typography>;
    }
  };

  return (
    <div
      style={{ cursor: "pointer" }}
      className={isRead ? classes.readContainer : classes.unreadContainer}
      onClick={async (event) => {
        event.stopPropagation();
        const returnedObj = await readNotifications(
          notificationDetails.id,
          notificationDetails,
        );
        if (returnedObj.is_read) {
          setIsRead(returnedObj.is_read);
        }
      }}
    >
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Checkbox
          checked={checkedNotifications?.indexOf(notificationDetails.id) !== -1}
          onChange={(event) => {
            handleChange(event, notificationDetails.id);
          }}
          size="small"
        />
      </div>
      {trackableIcon(notificationDetails?.notification_object?.content_type)}
      <div className={classes.descriptionContainer}>
        <div className={classes.description}>
          {getNotificationText(notificationDetails)}
        </div>

        <div className={classes.hoverContainer}>
          <div
            className={
              notificationIds.length > 0
                ? classes.notdisplayElement
                : classes.displayElement
            }
          >
            <Button
              className={classes.iconBtn}
              onClick={(event) =>
                handleDeleteNotification(event, notificationDetails.id)
              }
            >
              <Trash size={18} color="#FF0000" />
            </Button>
            {isRead ? (
              <Button
                className={classes.iconBtn}
                onClick={async (event) => {
                  event.stopPropagation();
                  const returnedObj = await readOneNotification(
                    notificationDetails.id,
                    false,
                  );
                  if (returnedObj) {
                    setIsRead(returnedObj.is_read);
                  }
                }}
              >
                <EnvelopeSimpleOpen size={18} color="#6C65D9" />
              </Button>
            ) : (
              <Button
                className={classes.iconBtn}
                onClick={async (event) => {
                  event.stopPropagation();
                  const returnedObj = await readOneNotification(
                    notificationDetails.id,
                    true,
                  );
                  if (returnedObj.is_read) {
                    setIsRead(returnedObj.is_read);
                  }
                }}
              >
                <EnvelopeSimple size={18} color="#6C65D9" />
              </Button>
            )}
          </div>
          <Typography className={classes.originalElement}>
            {new Intl.DateTimeFormat("en-IN", {
              day: "2-digit",
              month: "long",
              year: "numeric",
            }).format(new Date(notificationDetails?.created_at))}{" "}
            |{" "}
            {new Date(notificationDetails?.created_at).toLocaleTimeString(
              "en-US",
              { hour: "numeric", minute: "2-digit", hour12: true },
            )}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default NotificationInformation;
